import * as React from 'react';
import styled from 'styled-components';

import { Table } from 'components/bootstrap';
import { PaginatedList, Spinner } from 'components/common';
import { usePagination, useSetPagination } from 'common/contexts';
import { useGetEventProcedures } from 'security-app/hooks/useEventProceduresAPI';

import ListHeader from './ListHeader';
import ListRows from './ListRows';
import EventProcedureTabs from './EventProcedureTabs';

const TabsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;
  padding: 7px;
  background-color: ${({ theme }) => theme.colors.global.background};
  border-radius: 6px;
  width: 200px;
`;

type Props = {
  useCoreRoutes?: boolean;
};

function ProceduresList({ useCoreRoutes = false }: Props) {
  const localPagination = usePagination();
  const setLocalPagination = useSetPagination();

  const { eventProcedures, loadingEventProcedures, pagination } = useGetEventProcedures(localPagination);

  const onPageChange = (newPage: number, newPageSize: number) => {
    setLocalPagination({ ...localPagination, page: newPage, perPage: newPageSize });
  };

  return (
    <PaginatedList
      activePage={localPagination.page}
      pageSize={localPagination.perPage}
      onChange={onPageChange}
      totalItems={pagination.total}
      useQueryParameter={false}>
      <TabsContainer>
        <EventProcedureTabs viewType="procedures" useCoreRoutes={useCoreRoutes} />
      </TabsContainer>
      <Table condensed hover className="table table-striped" data-testid="event-procedure-list">
        <ListHeader />
        <tbody>
          {loadingEventProcedures ? (
            <tr>
              <td colSpan={4} aria-label="Loading Event Procedures">
                <Spinner text="Loading Event Procedures ..." />
              </td>
            </tr>
          ) : (
            <ListRows eventProcedures={eventProcedures} />
          )}
        </tbody>
      </Table>
    </PaginatedList>
  );
}

export default ProceduresList;
